/* src/app/ship/return-shipment/return-ship-to/return-ship-to-static/return-ship-to-static.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.return-ship-to-static {
  font-size: 0.9375rem;
  line-height: 1.47;
  padding-top: 1rem;
  margin-bottom: 2em;
}
.return-ship-to-static .name {
  font-weight: 700;
}
.return-ship-to-static .company {
  font-weight: 700;
}
.return-ship-to-static .address {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
}
.return-ship-to-static .address.vertical {
  flex-direction: column;
}
.return-ship-to-static .address span {
  margin-right: 0.25em;
}
.return-ship-to-static .address span:last-of-type {
  margin-right: 0;
}
.return-ship-to-static .options {
  margin-top: 0.9375rem;
}
.return-ship-to-static .options .mat-mdc-checkbox {
  font-size: 0.75rem !important;
}
.return-ship-to-static .email-wrapper {
  border-bottom: dotted 1px #004791;
  padding-bottom: 0.25em;
}
.return-ship-to-static .email-wrapper .material-icons {
  font-size: 1.2em;
  width: 1em;
  height: 1em;
}
/*# sourceMappingURL=return-ship-to-static.component.css.map */
